import { render, staticRenderFns } from "./MilestoneReference.vue?vue&type=template&id=7f2f36a0&scoped=true&"
import script from "./MilestoneReference.vue?vue&type=script&lang=js&"
export * from "./MilestoneReference.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneReference.vue?vue&type=style&index=0&id=7f2f36a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f36a0",
  null
  
)

export default component.exports